import ArrowBtn from 'components/buttons/ArrowBtn'
import React, { useEffect, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import ErrorMessage from 'components/Error'
import Popup from 'components/popups/Popup'
import Loading from 'components/Loading'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'

interface CodePreviewProps {
  contractId: string
}

export interface LockResponse {
  locks: Lock[]
}

export interface Lock {
  warehouseId: string
  warehouseNumber: string
  placeAdress: string
  isPinRequired: boolean
  pages: LockPage[]
}

interface LockPage {
  img: string
  sections: LockPageSection[]
}

interface LockPageSection {
  title: string
  content: string
  pinPrefix?: string
  pin?: string
  type: 'text' | 'phone' | 'infoModal' | 'pin' | 'prefixed_pin'
}

const CodePreview: React.FC<CodePreviewProps> = ({ contractId }) => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState<null | Lock>(null)

  const { goBack } = useHistory()
  const { t } = useTranslation('basic')
  const getContracts = async (ids: string[]) => {
    setLoading(true)
    try {
      const response: LockResponse = await POST(urls.contracts, { body: { ids } })
      if (response?.locks?.[0]?.warehouseId) {
        setData(response.locks[0])
        setLoading(false)
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getContracts([contractId])
  }, [contractId])

  return (
    <Popup>
      <div className='codePreview__popup'>
        {isLoading
          ? <Loading />
          : data
            ? <div className='detailsSlide'>
              <div className='detailsSlide__body'>
                {data.pages.map((page, idx) => {
                  const section = page.sections.find(section => section.type.includes('pin'))
                  if (section) {
                    return <div key={idx} className='section'>
                      <div className='section__title'>
                        <h2>{section.title}</h2>
                      </div>
                      <div className='section__content'>
                        {section.type === 'pin'
                          ? section.content.split('').map((char, index) => (
                            <div key={index} className='rec'>{char}</div>
                          ))
                          : <>
                            {section.pinPrefix && section.pinPrefix.split('').map((char, index) => (
                              <div key={index} className='rec --primary'>{char}</div>
                            ))}
                            {section.pin?.split('').map((char, index) => (
                              <div key={index} className='rec'>{char}</div>
                            ))}
                          </>}
                      </div>
                    </div>

                  } else {
                    return null
                  }
                })}
              </div>

              <div className='detailsSlide__footer'>
                <ArrowBtn
                  enlarged
                  text={t('close')}
                  action={goBack}
                />
              </div>
            </div>
            : <ErrorMessage staticPos />}
      </div>
    </Popup>
  )
}

export default CodePreview